module.exports = __webpack_public_path__ + "static/media/frozen6.17ad9fd3.png";